var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"wrapper"},_vm.inputListeners),[_c('div',{staticClass:"fade",class:{ 'fade-out': _vm.show, 'fade-in': !_vm.show }},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"operator"},[_vm._t("operator")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }